import React, { useRef, useMemo, useState, useEffect } from 'react';
import styles from "../components/DataTreeNode/DataTreeNode.module.js";

/**
 * This hook handles the focus state inside the data-tree element.
 * @param loadedElements
 * @return focusElement - element which will be focused
 * @return elementIndex - index where the element should be added
 * @return doFocus - function which will trigger the focus
 */
import { jsx as _jsx } from "react/jsx-runtime";
export function useFocusControl(loadedElements) {
  const [lastLoadedElementsCounter, setLastLoadedElementsCounter] = useState(0);
  const [elementIndex, setElementIndex] = useState(-1);
  const [shouldFocus, setShouldFocus] = useState(false);
  const focusRef = useRef(null);
  useEffect(() => {
    // calculate the index where the focus element should be added
    setElementIndex(lastLoadedElementsCounter - 2);
    // save the last position to get the diff in the next iteration
    setLastLoadedElementsCounter(loadedElements.length);
  }, [loadedElements, lastLoadedElementsCounter]);
  const focusElement = useMemo(() => /*#__PURE__*/_jsx("span", {
    ref: focusRef,
    tabIndex: -1,
    onBlur: () => setShouldFocus(false),
    className: styles.excludedChild
  }), []);
  useEffect(() => {
    // re-focus if elementIndex changes because focusElement may re-render after doFocus
    if (shouldFocus) {
      focusRef.current?.focus({
        preventScroll: true
      });
    }
  }, [elementIndex, shouldFocus]);
  return useMemo(() => ({
    focusElement,
    elementIndex,
    doFocus: () => {
      setShouldFocus(true);
    }
  }), [elementIndex, focusElement]);
}